// extracted by mini-css-extract-plugin
export default {"container":"_k","overlay":"al","videoOverlay":"bl","withHeader":"cl","header":"dl","close":"el","content":"fl"};